export default __webpack_public_path__ + "static/media/MAM.256.f5119a77.png";